module.exports = __webpack_public_path__ + "static/Serpentine-section-Desktop-63993eb8b9879bf84705f31fd6fd37d3.jpg";